module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/af5cafbff5e8c2ccbb54e08031cf1845.png";